import Header from '../components/header';
import Footer from '../components/footer';
import Script from 'next/script';
import klaroConfig from '../public/klaro-config';

export default function Layout({ children }) {
  return (
    <>
      <Script
        id="klaro-config"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `window.klaroConfig = ${JSON.stringify(klaroConfig)};`,
        }}
      />
      <Script
        src="/klaro.js"
        strategy="lazyOnload"
        onLoad={() => {
          if (window.Klaro) {
            window.Klaro.initialize(window.klaroConfig);
          }
        }}
      />
      <div id="klaro" />
      <Script>{`  var _paq = window._paq = window._paq || [];
  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  (function() {
    let u="https://www.shoppilot.de/anly/matomo/";
    _paq.push(['setTrackerUrl', u+'matomo.php']);
    _paq.push(['setSiteId', '2']);
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
  })();`}
      </Script>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}
